export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "TextCopy",
            data: {                
                    editable: true,
                    value:  settings[name],
                    placeholder: "Введите публичный SSH ключ",
                    onChange
                
            }
        }
    ]
}